import { useEffect } from 'react';
import { useAvailableMembersStore } from '@/store/availableMembersStore';

export const useAvailableMembers = () => {
  const { members: availableMembers, isLoading, error, fetchMembers, cleanup } = useAvailableMembersStore();

  useEffect(() => {
    // Initial fetch
    fetchMembers();

    // Cleanup on unmount
    return () => {
      cleanup();
    };
  }, [fetchMembers, cleanup]);

  return {
    availableMembers,
    isLoading,
    error,
    refetch: fetchMembers
  };
};